'use client';

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Search, Tag, ChevronRight } from 'lucide-react';
import Footer from '@/components/Footer';
import { COMERCIO_DATA } from '@/lib/comercio-data';


export default function ComercioPage() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredCategories = COMERCIO_DATA.filter(cat => 
    cat.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-emerald-200 selection:text-emerald-900">
      {/* Header */}
      <header className="bg-gradient-to-r from-emerald-600 to-teal-700 text-white shadow-lg">
        <div className="max-w-4xl mx-auto px-4 py-12 md:py-20 text-center space-y-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 px-6 py-3 rounded-2xl text-white font-black uppercase tracking-tighter italic transition-all hover:-translate-x-1 active:scale-95 mb-8 group shadow-lg"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            Voltar para o Início
          </Link>
          <h1 className="text-3xl md:text-5xl font-black tracking-tighter uppercase italic">
            Guia Comercial <br className="md:hidden" />
            <span className="text-emerald-200">Catanduvas PR</span>
          </h1>
          <p className="text-emerald-100 text-lg md:text-xl font-medium max-w-2xl mx-auto">
            Selecione uma categoria abaixo para ver as empresas locais.
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 -mt-8 pb-20">
        {/* Search Bar */}
        <div className="relative group mb-10">
          <div className="absolute inset-y-0 left-0 pl-6 flex items-center pointer-events-none">
            <Search className="h-6 w-6 text-slate-400 group-focus-within:text-emerald-600 transition-colors" />
          </div>
          <input
            type="text"
            placeholder="Buscar categoria..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className="block w-full pl-16 pr-6 py-6 bg-white border-none rounded-[2rem] text-xl shadow-2xl focus:ring-4 focus:ring-emerald-500/20 transition-all outline-none placeholder:text-slate-400"
          />
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCategories.map(cat => (
            <Link
              key={cat.id}
              to={`/comercio/${cat.id}`}
              className="flex flex-col items-center justify-center p-8 rounded-[2.5rem] bg-white border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all group text-center"
            >
              <div className={`p-5 rounded-3xl mb-4 transition-all group-hover:scale-110 shadow-lg ${cat.color} text-white`}>
                {cat.icon}
              </div>
              <span className="font-black uppercase tracking-tighter italic text-lg leading-tight text-slate-800 group-hover:text-emerald-600 transition-colors">
                {cat.category}
              </span>
              <div className="mt-4 flex items-center gap-1 text-slate-400 font-bold text-xs uppercase tracking-widest group-hover:text-emerald-500 transition-colors">
                Ver empresas <ChevronRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>

        {filteredCategories.length === 0 && (
          <div className="text-center py-20 bg-white rounded-[2.5rem] border border-dashed border-slate-300">
            <Tag className="w-16 h-16 text-slate-300 mx-auto mb-4" />
            <h3 className="text-xl font-bold text-slate-800">Nenhuma categoria encontrada</h3>
            <p className="text-slate-500 mt-2">Tente buscar por outro termo.</p>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
